import { useFocused, useSelected } from 'slate-react'
import React from 'react'

import { Absolute } from '../../../kiti/components/helpers/Position'
import { useEditorState } from '../EditorContext'
import Icon from '../../../kiti/components/shapes/Icon'
import InterpolationPlugin from './InterpolationPlugin'
import Panel from '../../../kiti/components/structure/Panel'
import Text from '../../../kiti/components/presentation/Text'

const formatSize = (value, defaultValue) => {
  if (!value) return defaultValue
  return value + 'px'
}

const Element = ({ children, attributes, element, ...props }) => {
  const { setMenu } = useEditorState()
  const selected = useSelected()
  const focused = useFocused()

  //<Tag label={element.name} color="dark3" borderColor={selected && focused && 'lightBlue'} />

  return (
    <div
      {...attributes}
      contentEditable={false}
      style={{
        display: 'inline-block',
        boxShadow: selected ? '0 0 0 3px #B4D5FF' : 'none',
        position: 'relative'
      }}
    >
      <Text align="center">{children}</Text>
      <Panel
        justify="center"
        align="center"
        width={formatSize(element.max_width, '300px')}
        height={formatSize(element.max_height, '250px')}
        bgColor="light2"
      >
        {element.name}
      </Panel>

      {selected && (
        <Absolute top={0.4} right={0.4}>
          <Panel bgColor="dark3" padding={0.6} onClick={() => setMenu('image')}>
            <Icon name="RiPencilLine" color="white" />
          </Panel>
        </Absolute>
      )}
    </div>
  )
}

const ImagesInterpolationPlugin = {
  ...InterpolationPlugin,
  Element
}

export default ImagesInterpolationPlugin
